import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const videoData = [
  "https://res.cloudinary.com/dzngpgki4/video/upload/v1744223779/c7sxptbabat73g75fjl7.mp4", // Records
  "https://res.cloudinary.com/dzngpgki4/video/upload/v1744223813/yfe3j4npfdq4krqly6cj.mp4", // Reports
  "https://res.cloudinary.com/dzngpgki4/video/upload/v1744223814/agxxfex5imknnkurmp0a.mp4", // Service providers
  null, // Resources ❌ no video
  "https://res.cloudinary.com/dzngpgki4/video/upload/v1744223826/g5tzh6p6dojv29rjfwfj.mp4", // Contracts
  null, // Communities ❌ no video
];


const Solutions = () => {
  const swiperRef = useRef(null);
  const [showVideo, setShowVideo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const openVideo = (url) => {
    setVideoUrl(url);
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
    setVideoUrl("");
  };

  return (
    <div className="relative bg-white md:pb-3  pb-2">
      {/* Background Layer */}
      <div className="absolute top-0 left-0 w-full h-4/5 bg-[#152C24] z-0"></div>

      {/* Content */}
      <div className="relative z-10 px-4 md:px-20   m">
        {/* Heading */}
        <div className="flex items-center pt-2  md:mt-3  md:px-4  md:mb-3">
          <h1 className="text-[12px] md:text-[40px] font-bold text-white  tracking-wide">
            Experience Farmnet App
          </h1>
        </div>

        {/* Swiper + Slides */}
        <div className="bg-[#2E453D] rounded-md w-full md:h-full h-[150px] relative flex items-center justify-center  mt-2 p-2 md:p-0 md:mt-6">
          <Swiper
            ref={swiperRef}
            spaceBetween={50}
            slidesPerView={1}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
          >
            {[
              {
                title: "Records",
                description: "Record keeping on the go, with real-time updated dashboards",
                mobileText: "Record keeping on the go",
                imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_qw0fkn.png"
              },
              {
                title: "Reports",
                description: "Value chain gains visibility of entire farming cycle",
                mobileText: "Reports on the go",
                imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_2_ccjrnn.png"
              },
              {
                title: "Service providers",
                description: "Farmers get support from verified service providers",
                mobileText: "Contracts on the go",
                imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_4_upyybh.png"
              },
              {
                title: "Resources",
                description: "Farmers Access Inputs for production",
                mobileText: "Reports on the go",
                imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_3_rnbzmi.png"
              },
              {
                title: "Contracts",
                description: "Farmers assured of market for produce",
                mobileText: "Reports on the go",
                imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_1_yiafp3.png"
              },
              {
                title: "Communities",
                description: "Farmers mobilize resources and share best practise",
                mobileText: "Reports on the go",
                imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_5_f9hriz.png"
              }
            ].map((slide, index) => (
              <SwiperSlide key={index} className="mx-auto">
              <div className="rounded-xl overflow-hidden relative flex justify-center items-center md:mt-5">
  <img
    src={slide.imageUrl}
    alt="Mobile"
    className="object-cover w-[20%] h-[40%] md:w-[22.5%] md:h-[79%] object-center md:mb-5"
  />
  <div className="absolute inset-0 flex justify-center items-center">
    <img
      onClick={() => openVideo(videoData[index])}
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
      alt="Play Icon"
      className="w-[50px] h-[50px] md:w-[130px] md:h-[130px] object-contain cursor-pointer"
    />
  </div>
</div>

                <div className="absolute -bottom-[15px] md:bottom-2.5 left-4 md:left-10 text-white mb-4">
                  <p className='text-[11px] md:text-[43px] font-bold text-[#FCC153]'>{slide.title}</p>
                  <p className="md:block hidden md:mt-1 text-[10px] md:text-[20px] md:w-[450px]" style={{lineHeight:'1.20'}}>{slide.description}</p>
                  <p className="md:mt-1 text-[7px] md:text-[24px] block md:hidden" style={{ lineHeight: '1.10' }}>
                    {slide.mobileText}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Logo */}
          <div className="absolute left-4 md:left-6 top-0 md:-top-1 w-[70px] md:w-[150px] h-[50px] md:h-[80px] z-10">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>

          {/* See More Button */}
          <div className="absolute bottom-0 right-0 bg-[#152C24] z-20 rounded-tl-[30px] flex items-center justify-evenly md:px-4 px-1 w-[80px] h-[25px] md:w-[228px] md:h-[82px]">
           <a href='/experiencemain'>
           <div className='flex items-center justify-between space-x-3 md:space-x-5 mt-1 md:mt-1 ml-2 md:ml-7 '>
              <p className='text-[8px] md:text-[23.5px] text-white font-bold'>See more</p>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                alt="Expand"
                className="w-[15px] md:flex hidden md:w-[40px] h-[20px] md:h-[50px] object-contain"
              />
                <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                alt="Expand"
                className="w-[15px] md:hidden flex  md:w-[15px] h-[20px] md:h-[50px] object-contain"
              />
            </div>
           </a>
          </div>
          <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743894055/Arrow_drop_left_ywufj5.png"
                alt="Left Arrow"
                className="md:block absolute left-4 top-1/2 transform -translate-y-1/2 w-8 h-8 md:w-20 md:h-20 z-10 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  swiperRef.current.swiper.slidePrev();
                }}
              />

              {/* Custom Right Arrow */}
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743894091/Arrow_drop_left_1_othpaw.png"
                alt="Right Arrow"
                className="md:block absolute right-4 top-1/2 transform -translate-y-1/2 w-8 h-8 md:w-20 md:h-20 z-10 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  swiperRef.current.swiper.slideNext();
                }}
              />
           
        </div>
      </div>

      {/* Fullscreen Video Modal */}
      {showVideo && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center p-20">
          <video src={videoUrl} controls autoPlay className="w-full h-full object-contain" />
          <button
            onClick={closeVideo}
            className="absolute top-5 right-5 text-white text-3xl font-bold z-50"
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
};

export default Solutions;
